import { render, staticRenderFns } from "./MRitualEditSectionName.vue?vue&type=template&id=a254a8c6&scoped=true"
import script from "./MRitualEditSectionName.vue?vue&type=script&lang=ts"
export * from "./MRitualEditSectionName.vue?vue&type=script&lang=ts"
import style0 from "./MRitualEditSectionName.vue?vue&type=style&index=0&id=a254a8c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.4.37_css-loader@6.11.0_webpack@5.93.0__ejs@3.1.10_hoga_mqdlk73zogqfmm4uknw3a3yvy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a254a8c6",
  null
  
)

export default component.exports